import { ComputeStatus, TargetStatus } from "@biggeo/bg-server-lib/studio";
import { DataSourceConfigStatusWrapper } from "../../common/components/DataSourceConfigStatusWrapper";
import { ToggleDatasetCellItem } from "../../common/components/ToggleDatasetCellItem";
import { getLinearGradient } from "../../common/utils/gradient";
import { SetDatasetContextType } from "../mapbox/context/utils/general-utils";
import { MapContextDataset } from "../mapbox/context/types";
import { getDatasetShapeColor } from "../utils/style-utils";

interface IDatasetCellItem
    extends Pick<SetDatasetContextType, "updateDataset"> {
    dataset: MapContextDataset;
    index: number;
    manageCompute: () => void;
    onItemClick: (dataset: MapContextDataset) => void;
}

const DatasetCellItem = ({
    dataset,
    updateDataset,
    index,
    manageCompute,
    onItemClick,
}: IDatasetCellItem) => {
    const { heatmap } = getDatasetShapeColor(dataset);

    const heatmapGradient = getLinearGradient(heatmap);

    return (
        <DataSourceConfigStatusWrapper
            fkDatasourceId={dataset.dataSource.id}
            fkOrganizationId={dataset.dataSourceConfiguration.fkOrganizationId}
            status={
                dataset.dataSourceConfiguration.status || ComputeStatus.loading
            }
            updateDataset={updateDataset}
        >
            {({ status }) => {
                return (
                    <ToggleDatasetCellItem
                        key={dataset.dataSource.id}
                        item={{
                            ...dataset,
                            dataSourceConfiguration: {
                                ...dataset.dataSourceConfiguration,
                                status,
                            },
                        }}
                        gradient={heatmapGradient}
                        manageCompute={manageCompute}
                        onItemClick={() => onItemClick(dataset)}
                        index={index}
                        updateDataset={updateDataset}
                        disabled={
                            status === ComputeStatus.cold ||
                            dataset.dataSourceConfiguration.targetState ===
                                TargetStatus.cold
                        }
                    />
                );
            }}
        </DataSourceConfigStatusWrapper>
    );
};

export default DatasetCellItem;
